// extracted by mini-css-extract-plugin
export default {"base":"Avatar_base__3+fdt","text":"Avatar_text__n+d-L"};